/* eslint-disable no-unused-vars */
import React from "react";
import { LoginButton } from "@telegram-auth/react";
import { telegramLogin } from "../../classes/player";
import { getStorageParams, removeNulls } from "../../classes/utills";
import config from "../../config";
import { go } from "../../classes/routesLazy";
function TelegramLogin() {
	// return (
	// 	<div
	// 		onClick={async () => {
	// 			const result = await telegramLogin({
	// 				hostname: "dev.wintomato.com",
	// 				id: 577662147,
	// 				first_name: "George",
	// 				username: "george_dev",
	// 				photo_url: "https://t.me/i/userpic/320/aQr0ZjEeWeMs7prifotpk-AiqZafwVdvuRUInECA4RY.jpg",
	// 				auth_date: 1757330158,
	// 				hash: "7125b898b711a4ea4e7062a7b37baff709a9f1828f07609bf96727d9a7bd2f55",
	// 			});
	// 		}}
	// 	>
	// 		button
	// 	</div>
	// );
	return (
		<div className="TelegramLoginButton">
			<LoginButton
				botUsername={config.telegramLogin[window.location.hostname] ?? ""}
				buttonSize="large" // "large" | "medium" | "small"
				cornerRadius={5} // 0 - 20
				showAvatar={false} // true | false
				lang="en"
				onAuthCallback={async (data) => {
					const storageParams = removeNulls(getStorageParams());
					const result = await telegramLogin({
						...storageParams,
						...data,
						hostname: window.location.hostname,
					});
					if (!result.error) go("home");
				}}
			/>
		</div>
	);
}
export default TelegramLogin;
